import { Box, Button, Dialog, DialogActions, DialogContent, Stack, Typography, useTheme } from '@mui/material';
import { useContext, useEffect, useState } from 'react';

import { Actions, AppContext } from '@Context/common/general/context';

import { ActionError } from '@Context/common/general/initial-state.constants';
import type { ErrorState } from '@Context/common/general/initial-state.types';
import useI18n from "@i18n";

export default function () {
  const theme = useTheme();
  const { state, dispatch } = useContext(AppContext);
  const { i18n, i18nExists } = useI18n();
  const [currentError, setCurrentError] = useState<ErrorState | null>(null);
  const [errorStack, setErrorStack] = useState<Array<ErrorState>>([]);

  useEffect(()=>{
    if(state.error.active) {  
      if(currentError !== state.error) {
        let currentStack = errorStack;
        currentStack.push(state.error);
        setErrorStack(currentStack);
        setCurrentError(currentStack[currentStack.length-1]);
      }
    } else if(errorStack.length > 0) {
      setCurrentError(errorStack[errorStack.length-1]);
    }
  }, [state.error]);

  
  useEffect(()=>{
    if(currentError) {
      console.error(currentError);
    }
  }, [currentError]);

  const handleClose = () => {
    // remove current top of stack
    let updatedStack = errorStack;
    updatedStack.pop();
    setErrorStack(updatedStack);
    setCurrentError(updatedStack[updatedStack.length-1]);
    // set current to the next in list
  };

  const handleRetry = () => {
    let updatedStack = errorStack;
    updatedStack.pop();
    setErrorStack(updatedStack);
    if(currentError) {
      currentError.retryHandler?.emit(()=>{
        dispatch({ type: Actions.CoreActions.CloseError });
      });
    }
    setCurrentError(null);
  }

  return (
    currentError && (
      <Dialog open={!!(currentError && currentError.active)} disableEscapeKeyDown={true}>
        <DialogContent>
          <Stack spacing={2}>
            <Typography
              color="dsBase.v200"
              sx={{
                fontSize: theme.spacing(3),
              }}
            >
              {i18nExists(currentError.title) ? i18n(currentError.title) : i18n(`error.default.${currentError.type}.title`)}
            </Typography>

            <Typography
              color="dsBase.v200"
              sx={{
                fontSize: theme.spacing(2),
              }}
            >
              {i18nExists(currentError.message) ? i18n(currentError.message) : i18n(`error.default.${currentError.type}.message`)}
            </Typography>
          </Stack>
        </DialogContent>
        <DialogActions>
          {currentError.retryHandler && currentError.type !== ActionError.MessageOnly && (
            <Button onClick={handleRetry} color="primary">
              {i18n("retry")}
            </Button>
          )}
          <Button onClick={handleClose} color="secondary">
            {i18n("close")}
          </Button>
        </DialogActions>
      </Dialog>
    )
  );
}
